import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { QuaiManager_DropDownCaret } from '@app/styles';
import { EpidemiologyRateLabelMap, EpidemiologyRates, EpidemiologyTypeLabelMap, EpidemiologyTypes } from '@app/dp-shared';
export const Props_EpidemiologyTypeDropDown = {
    adapter: () => SimpleListAdapter([...EpidemiologyTypes], type => _jsx(_Fragment, { children: EpidemiologyTypeLabelMap[type.item] })),
    placeholder: 'Pick Type',
    caret: QuaiManager_DropDownCaret,
};
export const Props_EpidemiologyRateDropDown = {
    adapter: () => SimpleListAdapter([...EpidemiologyRates], rate => _jsx(_Fragment, { children: EpidemiologyRateLabelMap[rate.item] })),
    placeholder: 'Pick Rate',
    caret: QuaiManager_DropDownCaret,
};
export const DropDown_EpidemiologyType = TS_DropDown.prepare(Props_EpidemiologyTypeDropDown);
export const DropDown_EpidemiologyRate = TS_DropDown.prepare(Props_EpidemiologyRateDropDown);
//# sourceMappingURL=ui-components.js.map